export const dateMask = value => {
    if (value.length < 3)
        return value
    if (value[2] === '/')
        return value
    let first_part = value.slice(0, 2)
    let second_part = value.slice(2)
    return first_part.concat('/').concat(second_part)
}